module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"msgs":{"0":"Upload File","1":"Replace File","2":"Add More Files","3":"I agree to Dubai Financial Market’s Terms and Conditions","4":"Thank You","5":"Your application has been submitted"}},"ar":{"msgs":{"0":"رفع ملف","1":"استبدل الملف","2":"إضافة المزيد من الملفات","3":"أوافق على شروط وأحكام سوق دبي المالي","4":"شكرًا لك","5":"تطبيقاتك تمت تقديمها"}}}')
  delete Component.options._Ctor
}
